import { Pipe, PipeTransform } from '@angular/core';
import {WP_REST_API_Attachment} from "wp-types";
import {WordpressService} from "../../services/wordpress.service";
@Pipe({
  name: 'attachmentFromId',
  standalone: true
})
export class AttachmentFromIdPipe implements PipeTransform {

  constructor(public wp : WordpressService) {
  }
  transform(id: number|WP_REST_API_Attachment): Promise<WP_REST_API_Attachment|null> {
    return new Promise<WP_REST_API_Attachment|null>(async (resolve) => {
      if (typeof id === 'object') {
        resolve(id);
        return;
      } else {
        const media = await this.wp.getAttachment(id);
        resolve(media)
      }
    });
  }

}
